import { render, staticRenderFns } from "./footerbar.html?vue&type=template&id=48ad367a&"
import script from "./footerbar.js?vue&type=script&lang=js&"
export * from "./footerbar.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports